import React, { useEffect, useState } from "react";
import PageHeader from "../../../componentsII/PageHeader";
import CardsStatus from "../../../componentsII/CardsStatus";
import api from "../../../axios/api";
import { useDispatch, useSelector } from "react-redux";
import { showNotification } from "../../../redux/slices/notificationSlice";
import car from "../../../images/car.png";
import Loader from "../../../componentsII/Loader";
import { Box, Modal } from "@mui/material";
import { X } from "lucide-react";
import VehicleUsageFuelDetailModal from "../../../components/VehicleUsageFuel/VehicleUsageFuelDetailModal";

const VehicleUsageFuel = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [vehiclesWithData, setVehiclesWithData] = useState([]);
  const [vehiclesWithoutData, setVehiclesWithoutData] = useState([]);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [detailModalData, setDetailModalData] = useState({});

  const { user } = useSelector((state) => state);
  const year = useSelector((state) => state.user.selectedYear);
  const dispatch = useDispatch();

  const fetchVehicleData = async () => {
    setIsLoading(true);
    try {
      const response = await api.get(`/vehicle/getAllVehicleUsageFuel?company_id=${user.user?.company?.id}&year_id=${year.id}`
      );
      if (response.data.vehicles) {
        const transformedVehicles = response.data.vehicles.map((vehicle) => ({
          usage_id:vehicle.usage_id,
          vehicle_id: vehicle.vehicle.value,
          company_id: vehicle.vehicle.company_id,
          label: vehicle?.vehicle?.label,
          year: vehicle.vehicle.year,
          co2_emission_tones: vehicle?.vehicle?.co2_emission_tones,
          make_details: {
            make_name: vehicle?.vehicle?.make_details?.make_name || "Unknown Make",
          },
          model_details: {
            model_name: vehicle.vehicle.model_details.model_name || "Unknown Model",
          },
          veh_type_details: {
            type_name: vehicle.vehicle.veh_type_details.type_name || "Unknown Type",
          },
          veh_subtype_details: {
            sub_type_name: vehicle.vehicle.veh_subtype_details.sub_type_name || "Unknown Subtype",
          },
          fuel_usage: {fuel_usage_qty:vehicle.fuel_qty,fuel_type:vehicle.fuel,fuel_qty_type:vehicle.qty},
          veh_datatype_available: vehicle.vehicle.veh_datatype_available,
        }));
        // Split vehicles into with/without data
        const withData = transformedVehicles.filter(
          (v) =>
            v.fuel_usage?.fuel_usage_qty &&
            v.fuel_usage?.fuel_type?.fuel_id &&
            v.fuel_usage?.fuel_qty_type?.qty_id
        );
        
        const withoutData = transformedVehicles.filter(
          (v) =>
            !v.fuel_usage ||
            !v.fuel_usage.fuel_usage_qty ||
            !v.fuel_usage.fuel_type?.fuel_id ||
            !v.fuel_usage.fuel_qty_type?.qty_id
        );        
        setVehiclesWithData(withData);
        setVehiclesWithoutData(withoutData);
      }
    } catch (error) {
      console.error("Error fetching vehicle data:", error);
      dispatch(
        showNotification({
          message: "Error fetching vehicle data",
          type: "error",
        })
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
      fetchVehicleData();
  }, []);

  return (
    <div>
      <PageHeader
        title="Vehicle Usage (Fuel)"
        text={[
          "Click into each vehicle card in the left panel to add your vehicle data",
          "You'll need the type of fuel (e.g. Petrol) and amount of fuel used (e.g. 740 liters) during your reporting period",
        ]}
        buttonTitle=""
        handleClick={() => { }}
      >
        {isLoading ? (
          <div className="w-full h-[200px] flex justify-center items-center">
            <Loader />
          </div>
        ) : vehiclesWithData.length === 0 && vehiclesWithoutData.length === 0 ? (
          <div className="text-center py-16 bg-gray-50 rounded-lg">
            <img
              src="/vectors/Car.jpg"
              alt="No Data"
              className="w-80 h-80 mx-auto text-gray-400 mb-4"
            />
            <h3 className="text-xl font-medium text-gray-600 mb-2">
              No Vehicles Found
            </h3>
            <p className="text-gray-500">
              Add your first Vehicle to get started
            </p>
          </div>
        ) : (
          <CardsStatus
            img={car}
            text1={
              <div className="flex items-center">
                <p className="bg-red-200 w-8 h-8 flex justify-center items-center rounded-full mr-4">
                  {vehiclesWithoutData.length}
                </p>
                Vehicle(s) need to have data added
              </div>
            }
            text2={
              <div className="flex items-center">
                <p className="bg-green-200 w-8 h-8 flex justify-center items-center rounded-full mr-4">
                  {vehiclesWithData.length}
                </p>
                Done
              </div>
            }
            data1={vehiclesWithoutData}
            data2={vehiclesWithData}
            itemName="vehicle"
            buttonTitle1="+ Add Data"
            buttonTitle2="Edit Data"
            buttonIClassname="bg-green-600 hover:bg-green-700 text-white border border-green-500 font-medium w-full text-center flex justify-center hover:-translate-y-0"
            buttonIIClassname="bg-gray-50 hover:bg-gray-100 text-gray-900 border border-gray-900 font-medium w-full text-center flex justify-center hover:-translate-y-0"
            buttonClick={(item) => {
              setIsDetailModalOpen(true);
              setDetailModalData(item);
            }}
          />
        )}

        <Modal
          open={isDetailModalOpen}
          onClose={() => setIsDetailModalOpen(false)}
          aria-labelledby="vehicle-fuel-modal"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "50%",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              borderRadius: "8px",
              position: "relative",
            }}
          >
            <button
              onClick={() => setIsDetailModalOpen(false)}
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
            >
              <X size={24} />
            </button>
            <VehicleUsageFuelDetailModal
              detailModalData={detailModalData}
              refetch={fetchVehicleData}
              handleCloseMainDetailModal={() => setIsDetailModalOpen(false)}
            />
          </Box>
        </Modal>
      </PageHeader>
    </div>
  );
};

export default VehicleUsageFuel;